import { onWebformActivity } from "common/signalR";
import ActivityPanel from "components/ActivityPanel/ActivityPanel";
import React from "react";
import { WebformActivityCard } from "./WebformActivityCard";
import { useCurrentUser } from "common/SessionContext";

interface Props {
  webformId: number
  config: server.dto.ActivityPanelConfig
}

export const WebformActivityPanel = (props: Props) => {
  const currentUser = useCurrentUser();

  return <ActivityPanel<server.dto.WebformActivity>
    activityKey="webform"
    itemId={props.webformId}
    config={props.config}
    fetchActivities={(page, perPage) => window.CoreApi.WebformConfiguration.ListActivity({ itemId: props.webformId, page, perPage })}
    renderActivity={(activity => <WebformActivityCard key={activity.activityId} activity={activity} />)}
    onActivityRegisterFn={onWebformActivity}
    onActivity={(activity) => {
      const iAmActor = (activity.actor?.userId === currentUser.userId);

      return { refreshActivities: iAmActor };
    }}
  />
}
